import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { libraryStudentView } from "../../api/Library";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { imgBaseUrl } from "../../api/api";
import { formatToDate, formatToTime } from "../master/FormatToDateTime";
import usePrivateLink from "../config/usePrivateLink";
import LibraryLayout from "./LibraryLayout";

export default function LibraryStudentProfile() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [type, setType] = useState("CourseNFee");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hostelStudentId = queryParams.get("id");

  const getStudentDetails = async () => {
    setLoading(true);
    try {
      const response = await libraryStudentView(hostelStudentId);
      if (response.data.status) {
        setData(response?.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStudentDetails();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row">
                <LibraryLayout />
                <div className="col-12">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="card">
                        <div className="card-body">
                          <div className="user-avatar-section">
                            <div className="d-flex align-items-center flex-column">
                              <div
                                className="d-flex justify-content-center mb-4"
                                style={{ cursor: "pointer" }}
                              >
                                {data?.student?.profile_picture ? (
                                  <img
                                    src={`${imgBaseUrl}${data?.student?.profile_picture}`}
                                    alt="Student Profile"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="rounded-circle border border-1 border-primary d-flex align-items-center justify-content-center bg-label-primary"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      color: "white",
                                      fontSize: "50px",
                                      fontWeight: "600",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {data?.student_name
                                      ? data?.student_name.charAt(0)
                                      : "U"}
                                  </div>
                                )}
                              </div>
                              <div className="user-info text-center">
                                <h5>
                                  {data?.student_name}({data?.registration_no})
                                </h5>
                              </div>

                              <span className="badge bg-label-success rounded-pill">
                                {data?.status == "1" ? "Active" : "Inactive"}
                              </span>
                            </div>
                          </div>
                          <div className="border-bottom mb-2">
                            <h5 className="mb-0">Details</h5>
                          </div>
                          <div className="info-container">
                            <ul className="list-unstyled mb-6">
                              <li className="mb-2">
                                <span className="h6">Father's Name: </span>
                                <span>{data?.father_name}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Phone: </span>
                                <span>{data?.mobile}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Address: </span>
                                <span>{data?.address}</span>
                              </li>
                              <li className="mb-2">
                                <span className="h6">Joining Date: </span>
                                <span>{formatToDate(data?.joining_date)}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="nav-align-top">
                        <ul className="nav nav-pills flex-column flex-md-row flex-wrap mb-6 row-gap-2">
                          {hasAccess("/student/course_fee") && (
                            <li className="nav-item">
                              <button
                                className={`nav-link waves-effect waves-light ${
                                  type === "CourseNFee" ? "active" : ""
                                }`}
                                onClick={() => setType("CourseNFee")}
                              >
                                <i className="ri-group-line me-1_5" />
                                Student Details
                              </button>
                            </li>
                          )}
                          {hasAccess("/fees/transactions") && (
                            <li className="nav-item">
                              <button
                                className={`nav-link waves-effect waves-light ${
                                  type === "Transaction" ? "active" : ""
                                }`}
                                href="#"
                                onClick={() => setType("Transaction")}
                              >
                                <i className="ri-link-m me-1_5" />
                                Transaction Report
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card mb-6  ">
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table table-sm">
                                  <thead>
                                    <tr className="text-center text-nowrap">
                                      <th>#</th>
                                      <th>Library Name</th>
                                      <th>Library Fee</th>
                                      <th>Shift (Seat No)</th>
                                      <th>Timing</th>
                                      <th>Joining Date</th>
                                      <th>End Date</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>1</td>
                                      <td>{data?.library?.name}</td>
                                      <td>₹{data?.final_fee}</td>
                                      <td>
                                        {data?.shift?.name} (
                                        {data?.seat?.seat_no})
                                      </td>
                                      <td>
                                        {formatToTime(data?.shift?.start_time)}-
                                        {formatToTime(data?.shift?.end_time)}
                                      </td>
                                      <td>
                                        {formatToDate(data?.joining_date)}
                                      </td>
                                      <td>{formatToDate(data?.last_date)}</td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          <div className="card mb-6  ">
                            <div className="card-body">
                              <div className="table-responsive ">
                                <div className="d-flex justify-content-between align-items-center ">
                                  <h5 className="mb-0">Fee Records</h5>
                                </div>

                                <table className="table table-sm">
                                  <thead>
                                    <tr className="text-center text-nowrap">
                                      <th>#</th>
                                      <th>Month</th>
                                      <th>Total Amount</th>
                                      <th>Final Amount</th>
                                      <th>Paid</th>
                                      <th>Remaining</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data?.library_fees?.map((fee, index) => (
                                      <tr key={fee.id}>
                                        <td>{index + 1}</td>
                                        <td>{fee.month}</td>
                                        <td>₹{fee.total_amount}</td>
                                        <td className="text-success fw-bold">
                                          ₹{fee.final_amount}
                                        </td>

                                        <td>₹{fee.paid_amount ?? 0}</td>
                                        <td>₹{fee.left_amount}</td>
                                        <td></td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
